// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","content":"styles_content__OhNAZ","logoLink":"styles_logoLink__Je4U9","logo":"styles_logo__hTa5C","text":"styles_text__M-cht"};